var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24928_25164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4398 11.5499L12.2498 20.7399C11.124 21.8658 9.59699 22.4983 8.0048 22.4983C6.41262 22.4983 4.88565 21.8658 3.7598 20.7399C2.63396 19.6141 2.00146 18.0871 2.00146 16.4949C2.00146 14.9027 2.63396 13.3758 3.7598 12.2499L12.9498 3.05992C13.7004 2.30936 14.7183 1.8877 15.7798 1.8877C16.8413 1.8877 17.8592 2.30936 18.6098 3.05992C19.3604 3.81048 19.782 4.82846 19.782 5.88992C19.782 6.95138 19.3604 7.96936 18.6098 8.71992L9.4098 17.9099C9.03452 18.2852 8.52553 18.496 7.9948 18.496C7.46407 18.496 6.95508 18.2852 6.5798 17.9099C6.20452 17.5346 5.99369 17.0256 5.99369 16.4949C5.99369 15.9642 6.20452 15.4552 6.5798 15.0799L15.0698 6.59992",
    stroke: "#090A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24928_25164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.d64d3a9fd408e54041bf4b39d7843f42.svg";
export { ForwardRef as ReactComponent };